export { getTimePassedFromNow } from './getTimePassedFromNow';
export { getBadgePropsFromEventType } from './getBadgePropsFromEventType';
export { getTitleByEventType } from './getTitleByEventType';
